import {
  appendActionCardChip,
  countActionCardChips,
  MAX_FOLLOW_UP_ACTION_CARDS,
} from '@littlebird/action-cards';
import { toast } from 'sonner';

import {
  COMPOSER_FOCUS_REQUESTED,
  localChatEventsBus,
} from '@/features/chat/chat.events';
import { getDraftId } from '@/features/chat/composer-draft-id';
import { logError } from '@/lib/errorLogging';
import { littlebirdSdk } from '@/lib/sdk-init';
import { NEW_CHAT_ID } from '@/utils/constants';

import type { ActionCard } from '@littlebird/sdk';

export const attachActionCardToHomeComposer = (card: ActionCard): void => {
  const draftId = getDraftId(NEW_CHAT_ID, null);
  const { drafts } = littlebirdSdk.stores;
  const existing = drafts.getDraft(draftId);
  if (countActionCardChips(existing) >= MAX_FOLLOW_UP_ACTION_CARDS) {
    toast.error(
      `Attach at most ${MAX_FOLLOW_UP_ACTION_CARDS} cards to one message.`
    );
    return;
  }
  const withChip = appendActionCardChip(existing, card);
  const written = withChip
    ? drafts.updateDraft({ draftId, ...withChip })
    : Promise.resolve();

  void written.then(
    () => {
      localChatEventsBus.emit(COMPOSER_FOCUS_REQUESTED, { data: { draftId } });
    },
    (error: unknown) => {
      logError(error, 'Failed to attach an action card to the Home composer', {
        context: 'attachActionCardToHomeComposer',
        metadata: { cardId: card.id },
      });
    }
  );
};
